import { createFileRoute } from "@tanstack/react-router";

import { ResetPasswordPage } from "../components/auth/ResetPasswordPage";

/** What the gateway's reset link redirects to: a live token, or why there is none. */
export interface ResetPasswordSearch {
  token?: string;
  error?: string;
}

/**
 * Sets a new password from a mailed link. The link opens in a browser, so this
 * page is reached on the web entry; it needs no session.
 */
export const Route = createFileRoute("/reset-password")({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: typeof search.token === "string" && search.token.length > 0 ? search.token : undefined,
    error: typeof search.error === "string" && search.error.length > 0 ? search.error : undefined,
  }),
  component: ResetPasswordPage,
});
